export const getLogoSrc = (providerId: string, state: string) => {
  if (state) {
    return `https://dorzjv601fuva.cloudfront.net/${
      state.toLocaleLowerCase() === "tx" ? "tx" : "usn"
    }/${providerId}.png`;
  }
  return `https://www.powerlego.com/ApiGateway/v2/logo/provider/${providerId}`;
};
